/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { FlashMessagesNotificationTypes, FlashMessagesNotificationState } from './types';

const INITIAL_STATE: FlashMessagesNotificationState = {
  flash_messages_notification: {
    text: '',
    expired: false,
    url: '',
    show: false,
    boleto_receita_id: null,
  },
  feedback_notification: {
    text: '',
    class: '',
    show: false,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<FlashMessagesNotificationState> = (
  state = INITIAL_STATE,
  { type, result },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case FlashMessagesNotificationTypes.SHOW_REQUEST:
        draft.flash_messages_notification = INITIAL_STATE.flash_messages_notification;
        draft.request.loading = true;
        break;
      case FlashMessagesNotificationTypes.SHOW_SUCCESS:
        if (!result.data) return;

        draft.flash_messages_notification.show = true;
        draft.flash_messages_notification.text = result.data.mensagem;
        draft.flash_messages_notification.url = result.data.url;
        draft.flash_messages_notification.expired = result.data['is_expired?'];
        draft.flash_messages_notification.boleto_receita_id = result.data.boleto_receita_id ?? null;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case FlashMessagesNotificationTypes.SHOW_FAILURE:
        draft.flash_messages_notification = INITIAL_STATE.flash_messages_notification;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case FlashMessagesNotificationTypes.SHOW_FEEDBACK:
        draft.feedback_notification = {
          text: result.text,
          class: result.class,
          show: result.show,
        };
        break;
      case FlashMessagesNotificationTypes.READ_FEEDBACK:
        draft.feedback_notification = {
          text: '',
          class: '',
          show: false,
        };
        break;
      default:
    }
  });
};

export default reducer;
